var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.value.deletedAt
    ? _c("div")
    : "LinkButton" == _vm.value.type
    ? _c("TicketWidgetLinkButton", { attrs: { widget: _vm.value } })
    : "Link" == _vm.value.type
    ? _c("a", { attrs: { href: _vm.value.parameter } }, [
        _vm._v(_vm._s(_vm.value.label || _vm.value.id))
      ])
    : "TicketDetailLiteral" == _vm.value.type
    ? _c("TicketWidgetLiteral", { attrs: { widget: _vm.value } })
    : "TicketNewCenterContent" == _vm.value.type
    ? _c("TicketWidgetNewCenterContent")
    : "TicketDetailReplyForm" == _vm.value.type
    ? _c("TicketDetailReplyForm")
    : "MyTicketList" == _vm.value.type
    ? _c("TicketWidgetMyTicketList", { attrs: { widget: _vm.value } })
    : "JS" == _vm.value.type
    ? _c("TicketWidgetJS", { attrs: { widget: _vm.value } })
    : "CSS" == _vm.value.type
    ? _c("TicketWidgetCSS", { attrs: { widget: _vm.value } })
    : "RightMerchantOrder" == _vm.value.type ||
      "RightMerchant" == _vm.value.type ||
      "RightShop" == _vm.value.type ||
      "RightCustomerSchedule" == _vm.value.type ||
      "RightCallInfo" == _vm.value.type ||
      "RightWorkflow" == _vm.value.type ||
      "RightEndAt" == _vm.value.type
    ? _c("TicketWidgetRightField", { attrs: { widget: _vm.value } })
    : "TopLeftTabPane" == _vm.value.type
    ? _c("TicketWidgetTopLeftTab", { attrs: { widget: _vm.value } })
    : "TicketDetailSegment" == _vm.value.type
    ? _c("TicketWidgetSegment", { attrs: { widget: _vm.value } })
    : "TicketWidgetRelated" == _vm.value.type
    ? _c("TicketWidgetRelated", { attrs: { widget: _vm.value } })
    : "TicketNewButton" == _vm.value.type || "TicketNewBtn" == _vm.value.type
    ? _c("TicketWidgetNewButton", { attrs: { widget: _vm.value } })
    : "AssignToWorkflowButton" == _vm.value.type
    ? _c("AssignToWorkflowButton", { attrs: { widget: _vm.value } })
    : _c("span", [_vm._v("TicketWidget else " + _vm._s(_vm.value))])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca78d95a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca78d95a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketWidget.vue
// module id = 862
// module chunks = 75